// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Report_attributes_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/report_attributes/remover/{id}
 *
 * Action endpoint — emits an empty success envelope (no dados payload).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Report_attributes_RemoverResponseDados = null;

export type Report_attributes_RemoverResponse = ApiResponse<Report_attributes_RemoverResponseDados>;

registerResponseContract('Report_attributes_RemoverResponse', {})
